export const headCellEmployee = [
  { id: "name", disablePadding: true, label: "Nombre" },
  { id: "email", disablePadding: true, label: "Email" },
  { id: "telephone", disablePadding: false, label: "Teléfono" },
  { id: "verified", disablePadding: false, label: "Usuario Verificado" },
  { id: "loginAttempts", disablePadding: false, label: "Intentos Loggeo" },
  { id: "password", disablePadding: false, label: "Password" },
  { id: "userBlocked", disablePadding: true, label: "Usuario Activo" },
  { id: "siteId", disablePadding: true, label: "Sucursal" },
  { id: "roleId", disablePadding: true, label: "Rol" },
  {
    id: "sells",
    disablePadding: true,
    label: "Ventas Generadas",
  },
];
